import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Button, Row, Col, message, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  getShipmentService,
  getMaterialService,
  getMetalsService,
  postShipmentSelectedService,
  postAddToShipmentService,
  putCompleteShipmentService,
  putMaterialService,
  deleteMaterialService,
  getCompletedBundlesService,
  postBundlesToShipmentService,
  getCategoriesService,
} from "./NewShipmentPageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import ScaleReading from "../../components/ScaleReading/ScaleReading";
import PurchaseForm from "../../components/PurchaseForm/PurchaseForm";
import Loader from "../../components/Loader/Loader";
import { removeTokenFromCookies } from "../../utils/cookies";
import Cookies from "universal-cookie";
import Copyright from "../../components/Copyright/Copyright";
import ScaleCamera from "../../components/ScaleCamera/ScaleCamera";
import "./NewShipmentPage.css";
import ShipmentForm from "../../components/ShipmentForm/ShipmentForm";
import { webcamDeviceIDs } from "../../constants/webcamIDs";

const { Content } = Layout;

export interface NewShipmentPageProps {
  scaleSerialPort: any;
  scaleReader: any;
  updateScaleSerialPort: (port: any) => void;
  updateScaleReader: (reader: any) => void;
}

const NewShipmentPage = (props: NewShipmentPageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [weight, setWeight] = useState("0.0");
  const [shipmentID, setShipmentID] = useState("");
  const [portAccessModalOpen, setPortAccessModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [weightReadingTextDummy, setWeightReadingTextDummy] = useState("");
  const [scaleImageSrc, setScaleImageSrc] = useState("");
  const [materialImageSrc, setMaterialImageSrc] = useState("");
  const [showSelectShipmentForm, setShowSelectShipmentForm] = useState(true);
  const [selectedShipmentInfo, setSelectedShipmentInfo] = useState({}) as any;
  let location = useLocation();
  let navigate = useNavigate();
  const scaleWebcamRef = useRef(null) as any;
  const materialWebcamRef = useRef(null) as any;
  const cookies = new Cookies();
  const token = cookies.get("TOKEN");
  const currOffice = cookies.get("CURR_OFFICE");

  useEffect(() => {
    navToSelectOffice();
    isPortEnabled();
  }, [token, props.scaleSerialPort]);

  useEffect(() => {
    if (props.scaleReader !== null) getReadingValue(props.scaleReader);
  }, [props.scaleReader, weightReadingTextDummy]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const isPortEnabled = () => {
    if (props.scaleSerialPort === null) setPortAccessModalOpen(true);
    // if (scaleSerialPort === null) setPortAccessModalOpen(true);
  };

  const getShipment = async (shipmentIDFromURL: string) => {
    try {
      setLoading(true);
      const res = await getShipmentService(shipmentIDFromURL);
      setShipmentID(res.data.shipmentID);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getShipment error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBundles = async () => {
    try {
      setLoading(true);
      const res = await getCompletedBundlesService();
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getBundles error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postBundlesToShipment = async (bundleIDs: String[]) => {
    try {
      setLoading(true);
      const payload = {
        bundleIDs: bundleIDs,
        shipmentID: shipmentID,
      };
      const res = await postBundlesToShipmentService(payload);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("postBundlesToShipment error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterial = async (materialID: string) => {
    try {
      setLoading(true);
      const res = await getMaterialService(materialID);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      // setMetals(res.data);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getCategories = async () => {
    try {
      setLoading(true);
      const res = await getCategoriesService();
      return res.data;
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getCategories error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postShipmentSelected = async (
    dateString: string,
    lorryNumberPlate: string,
    lorryDriver: string,
    shipmentDirection: string
  ) => {
    try {
      const dateProperties = dateString.split("/");
      const date =
        dateString !== "" && dateString !== undefined
          ? new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toISOString()
          : new Date().toISOString();
      setLoading(true);
      const payload = {
        date: date,
        lorryNumberPlate: lorryNumberPlate,
        lorryDriver: lorryDriver,
        origin: shipmentDirection,
        dest: shipmentDirection === "pg" ? "bw" : "pg",
      };
      const res = await postShipmentSelectedService(payload);

      if (res.data.shipmentID) {
        setSelectedShipmentInfo(res.data);
        setShowSelectShipmentForm(false);
        setShipmentID(res.data.shipmentID);
        window.history.pushState(null, "", `shipment/${res.data.shipmentID}`);
      }
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("postSupplierSelected error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSelectedShipmentInfo = (data: any) => {
    setSelectedShipmentInfo(data);
    setShowSelectShipmentForm(false);
  };

  const putMaterial = async (materialInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        materialID: materialInfo.materialID,
        name: materialInfo.name,
        rawWeight: materialInfo.rawWeight,
        wasteWeight: materialInfo.wasteWeight,
        netWeight: materialInfo.netWeight,
        manualEntry: materialInfo.manualEntry || materialInfo.originManualEntry,
        smallBag: materialInfo.smallBag,
        bigBag: materialInfo.bigBag,
        jumboBag: materialInfo.jumboBag,
        other: materialInfo.other,
        metalID: materialInfo.metalID,
        scaleImageSrc: scaleImageSrc,
        materialImageSrc: materialImageSrc,
        notes: materialInfo.notes,
      };
      const res = await putMaterialService(payload);
      setScaleImageSrc("");
      setMaterialImageSrc("");
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("putPurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postAddToShipment = async (materialInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        materialID: materialInfo.key,
        rawWeight: materialInfo.rawWeight,
        wasteWeight: materialInfo.wasteWeight,
        netWeight: materialInfo.netWeight,
        price: 0.0,
        shipmentID: shipmentID,
        notes: materialInfo.notes,
        manualEntry: materialInfo.manualEntry,
        smallBag: materialInfo.smallBag,
        bigBag: materialInfo.bigBag,
        jumboBag: materialInfo.jumboBag,
        other: materialInfo.other,
        office: currOffice,
        metalID: materialInfo.metalID,
        scaleImageSrc: scaleImageSrc,
        materialImageSrc: materialImageSrc,
        packageType: materialInfo.packageType,
      };
      const res = await postAddToShipmentService(payload);
      setScaleImageSrc("");
      setMaterialImageSrc("");
      setLoading(false);
      // console.log("res", res);
      return res.data;
      // if (res.data.purchaseID) setPurchaseID(res.data.purchaseID);
    } catch (e: any) {
      setLoading(false);
      console.error("postAddToShipment error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postCompleteShipment = async (
    materialsList: any[],
    notes: string,
    totalNetWeight: Number,
    totalNumMaterials: Number
  ) => {
    try {
      setLoading(true);
      const payload: any = {
        shipmentID: shipmentID,
        completed: true,
        notes: notes,
        totalNetWeight: totalNetWeight,
        totalNumMaterials: totalNumMaterials,
      };
      const resShipment = await getShipment(shipmentID);
      payload.purchaseDate = resShipment.createdTimestamp;
      const res = await putCompleteShipmentService(payload);
      setLoading(false);
      navigate("/shipments");
      // if (res.data.purchaseID) setPurchaseID(res.data.purchaseID);
    } catch (e: any) {
      setLoading(false);
      console.error("postCompletePurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const recordMaterial = () => {
    setScaleImageSrc("");
    setMaterialImageSrc("");
    setTimeout(() => {
      const scaleImage = captureScaleImage();
      const materialImage = captureMaterialImage();
      // return {
      //   rawWeight: Number(weight).toFixed(1),
      //   scaleImage: scaleImage,
      //   materialImage: materialImage,
      // };
    }, 500);
    return Number(weight).toFixed(1);
  };

  const captureScaleImage = useCallback(() => {
    if (scaleImageSrc === "") {
      if (scaleWebcamRef.current !== "") {
        const scaleImageSrc = scaleWebcamRef.current.getScreenshot();
        setScaleImageSrc(scaleImageSrc);
        return scaleImageSrc;
      } else {
        setScaleImageSrc("");
        setTimeout(() => {
          const scaleImageSrc = scaleWebcamRef.current.getScreenshot();
          setScaleImageSrc(scaleImageSrc);
          return scaleImageSrc;
        }, 1000);
      }
    }
  }, [scaleWebcamRef]);

  const captureMaterialImage = useCallback(() => {
    if (materialImageSrc === "") {
      if (materialWebcamRef.current !== "") {
        const materialImageSrc = materialWebcamRef.current.getScreenshot();
        setMaterialImageSrc(materialImageSrc);
        return materialImageSrc;
      } else {
        setMaterialImageSrc("");
        setTimeout(() => {
          const materialImageSrc = materialWebcamRef.current.getScreenshot();
          setMaterialImageSrc(materialImageSrc);
          return materialImageSrc;
        }, 1000);
      }
    }
  }, [materialWebcamRef]);

  const resetImageView = () => {
    setScaleImageSrc("");
    setMaterialImageSrc("");
  };

  const getReadingValue = async (reader: any) => {
    let weightReadingText = "";
    const { value, done } = await reader.read();
    setWeightReadingTextDummy(String(Math.random()));
    if (value) {
      weightReadingText += value;
      // console.log("reading,", weightReadingText);
      if (/\r\n/i.test(weightReadingText)) {
        let recordWeight = weightReadingText.trim().split("kg")[0];
        // console.log("raw", weightReadingText.trim().split("kg"));
        // console.log("net", recordWeight);
        // console.log("number", Number(recordWeight).toFixed(1));
        setWeight(Number(recordWeight).toFixed(1));
        weightReadingText = "";
      }
    }
    if (done) {
      reader.releaseLock();
    }
  };

  const getPortAccess = async () => {
    try {
      setPortAccessModalOpen(false);
      const port = await (window.navigator as any).serial.requestPort();
      props.updateScaleSerialPort(port);
      await port.open({ baudRate: 9600, bufferSize: 1000000 });
      const textDecoder = new TextDecoderStream();
      port.readable.pipeTo(textDecoder.writable);
      const reader = textDecoder.readable.getReader();
      props.updateScaleReader(reader);
    } catch (e: any) {
      setPortAccessModalOpen(false);
      console.error("getPortAccess error", e);
    }
  };

  const updateLoading = (loading: boolean) => {
    setLoading(loading);
  };

  const resetNewShipmentPage = () => {
    toggleSidebar(true);
  };

  const deleteMaterial = async (materialID: string) => {
    try {
      setLoading(true);
      const payload: any = {
        materialID: materialID,
        shipmentID: shipmentID,
        office: currOffice,
      };
      const res = await deleteMaterialService(payload);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("deleteMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Modal
        title="Allow COM port for Scale Reading (RS323)"
        open={portAccessModalOpen}
        okText="Allow"
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={getPortAccess}
        onCancel={() => setPortAccessModalOpen(false)}
      >
        <p>Select 'USB-Serial Controller (COM3)' and press Connect</p>
      </Modal>
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Col span={24}>
          <Header toggleSidebar={toggleSidebar} />
          <Row className="new-shipment-container">
            <Col style={{ width: "25%" }}>
              <Row className="new-shipment-weight-reading">
                <ScaleReading weight={weight} scaleSerialPort={props.scaleSerialPort} getPortAccess={getPortAccess} />
              </Row>
              <Row className="new-shipment-image-capture">
                <ScaleCamera
                  webcamRef={scaleWebcamRef}
                  webcamName="Scale"
                  imageSrc={scaleImageSrc}
                  // deviceID={webcamDeviceIDs.scaleCameraPG}
                  deviceID={currOffice === "pg" ? webcamDeviceIDs.scaleCameraPG : webcamDeviceIDs.scaleCameraBW}
                />
              </Row>
              <Row className="new-shipment-image-capture">
                <ScaleCamera
                  webcamRef={materialWebcamRef}
                  webcamName="Material"
                  imageSrc={materialImageSrc}
                  // deviceID={webcamDeviceIDs.materialCameraPG}
                  deviceID={currOffice === "pg" ? webcamDeviceIDs.scaleCameraPG : webcamDeviceIDs.scaleCameraBW}
                />
              </Row>
            </Col>
            <Col style={{ width: "75%" }} className="new-shipment-form">
              <ShipmentForm
                scaleSerialPort={props.scaleSerialPort}
                captureScaleImage={captureScaleImage}
                captureMaterialImage={captureMaterialImage}
                postShipmentSelected={postShipmentSelected}
                recordMaterial={recordMaterial}
                postAddToShipment={postAddToShipment}
                putMaterial={putMaterial}
                postCompleteShipment={postCompleteShipment}
                getShipment={getShipment}
                getMaterial={getMaterial}
                updateLoading={updateLoading}
                resetNewShipmentPage={resetNewShipmentPage}
                deleteMaterial={deleteMaterial}
                getMetals={getMetals}
                getCategories={getCategories}
                scaleImageSrc={scaleImageSrc}
                materialImageSrc={materialImageSrc}
                resetImageView={resetImageView}
                getBundles={getBundles}
                addBundlesToShipment={postBundlesToShipment}
                showSelectShipmentForm={showSelectShipmentForm}
                selectedShipmentInfo={selectedShipmentInfo}
                getSelectedShipmentInfo={getSelectedShipmentInfo}
              />
            </Col>
          </Row>
        </Col>
        <Copyright />
      </Content>
    </Layout>
  );
};

export default NewShipmentPage;
